import request from '@/utils/apiRequest'

// A1 - 获取区域树
export function getRegionTree() {
  return request({
    url: '/user/sceneItem/regionTree',
    method: 'get'
  })
}

// A2 - 按区域查询摄像头列表
export function getCameraList(regionId, name) {
  return request({
    url: '/user/sceneItem/cameraList',
    params: { regionId, name: name || undefined },
    method: 'get'
  })
}

// A3 - 获取摄像头详情
export function getCameraDetail(cameraIndexCode, withPreviewIframe = false) {
  return request({
    url: '/user/sceneItem/cameraDetail',
    params: { cameraIndexCode, withPreviewIframe },
    method: 'get'
  })
}

// B1 - 新增/更新设备标注
export function saveAnnotation(data) {
  return request({
    url: '/user/smartAccess/save',
    data: data,
    method: 'post'
  })
}

// B2 - 查询设备标注列表
export function getAnnotationList(type) {
  return request({
    url: '/user/smartAccess/list',
    params: { type: type || undefined },
    method: 'get'
  })
}

// B5 - 删除设备标注
export function removeAnnotation(id) {
  return request({
    url: '/user/smartAccess/remove',
    params: { id },
    method: 'get'
  })
}
